'use client';

import Image from 'next/image';
import { LinkButton } from '../button';
import { PageList } from '../page';
import { useMedia } from '@ssv-website/hooks';
import { Tooltip } from 'tdesign-react';

interface ISdkCardProps {
  title: string;
  subTitle: string;
  imageUrl: string;
  linkText?: string;
  linkHref?: string;
  tip?: string;
  themeStyle?: {
    backgroundColor: string;
    color: string;
  };
}

export const SdkCard: React.FC<ISdkCardProps> = ({
  imageUrl,
  title,
  subTitle,
  linkText,
  linkHref,
  tip,
  themeStyle,
}) => {
  return (
    <div
      className="relative flex bg-white rounded-lg justify-between mobile:aspect-auto"
      style={{ backgroundColor: themeStyle?.backgroundColor }}
    >
      <div className="p-[30px] flex flex-col justify-between mobile:p-5 desktop:p-5">
        <div>
          <span className="text-base leading-none text-primary mobile:text-sm font-500 line-clamp-1 break-all">
            {title}
          </span>
          <p className="text-sm text-primary/[.6] my-2 mobile:text-xs line-clamp-2 break-all desktop:line-clamp-1">
            {subTitle}
          </p>
          {tip && (
            <Tooltip
              content={`${tip}提供`}
              placement="top"
              destroyOnClose
              showArrow
            >
              <p className="text-sm -leading-[1px] text-active/[.6] mb-2 mobile:hidden line-clamp-1 break-all">
                {tip}提供
              </p>
            </Tooltip>
          )}
        </div>
        {linkText && (
          <LinkButton
            linkHref={linkHref || '/'}
            color={themeStyle?.color}
            className="desktop:mt-0"
            linkClassName="w-fit"
          >
            {linkText}
          </LinkButton>
        )}
      </div>
      <div className="aspect-[230/220] desktop:aspect-auto mobile:aspect-auto mobile:w-[128px] pb-5">
        <div className="aspect-[230/220] h-[220px] desktop:h-[160px] mobile:aspect-[128/122] mobile:w-[128px] mobile:h-auto">
          <Image
            src={imageUrl}
            alt="背景图片"
            height={440}
            width={460}
            className="w-full h-full rounded-r-lg mobile:rounded-br-none"
          />
        </div>
        {tip && (
          <div className="hidden mobile:block">
            <p className="text-xs text-active/[.6] text-center mt-2 mr-2 line-clamp-1 break-all">
              {tip}提供
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export const SdkCards = ({ data = [] }: { data: Array<ISdkCardProps> }) => {
  const isMobile = useMedia('mobile');
  return (
    <PageList
      data={data}
      className={`grid grid-cols-2 gap-5 gap-x-[14px] mobile:grid-cols-1 ${
        data.length > 3 ? 'mobile:grid-rows-3' : ''
      }`}
      columns={isMobile ? 3 : 6}
      renderItem={(m: any, i: number) => <SdkCard key={i} {...m} />}
    />
  );
};
